import apolloClient from "@/apollo";
import { type UserFragment, WorktimesWithoutUserDocument } from "@/gql/graphql";
import handleError from "@/handleError";
import { type AppThunk } from "@/store";

import { setUnconfirmedWorktimes } from "./worktimesReducer";

export const checkForUnconfirmedWorkTimes =
  (user: Pick<UserFragment, "id" | "__typename" | "customerId">): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await apolloClient.query({
        query: WorktimesWithoutUserDocument,
        variables: { customerId: user.customerId, filters: { unconfirmed: true, userId: user.id } },
      });

      if (data?.worktimes?.length) {
        dispatch(setUnconfirmedWorktimes(data.worktimes));
      }
    } catch (e) {
      handleError(e);
    }
  };
